/**
 * DevExtreme (esm/common/data/custom_store.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CustomStore from "../../__internal/data/m_custom_store";
function isGroupItem(item) {
  if (void 0 === item || null === item || "object" !== typeof item) {
    return false;
  }
  return "key" in item && "items" in item;
}
function isLoadResultObject(res) {
  return !Array.isArray(res) && "data" in res;
}
function isGroupItemsArray(res) {
  return Array.isArray(res) && !!res.length && isGroupItem(res[0]);
}
function isItemsArray(res) {
  return Array.isArray(res) && !isGroupItem(res[0]);
}
export { CustomStore, isLoadResultObject, isGroupItemsArray, isItemsArray };